export default __webpack_public_path__ + "static/m-banh2-8d2f2795b7b0675cff1cc54c268ba57c.jpg";